/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import { GearIcon } from '@trello/nachos/icons/gear';
import React from 'react';

import HeaderButton from './button';
import styles from './header.less';

const noop = () => {};

const classes = classNames(
  'paws-open-preferences',
  styles.desktopSettingsButton,
);

/**
 * This button has click handler binding in the desktop code via jQuery. Ugh.
 */
const DesktopSettingsButton: React.FunctionComponent = () => {
  return (
    <HeaderButton
      className={classes}
      icon={<GearIcon color="light" />}
      onClick={noop}
    />
  );
};

export default DesktopSettingsButton;
